import React from 'react'
import { FaCheck } from 'react-icons/fa'
import { Link } from 'react-router-dom'

export default function Pricing() {
  return (
    <>
    <div className="pricing-header px-1 py-1 pt-md-2 pb-md-1 mx-auto text-center">
      <h1 className="display-4">Pricing</h1>
      <p className="lead text-bold">for every business, at any stage.</p>
    </div>
    <div className="row">
        <div className="col-md-4">
            <div className="card mb-4 box-shadow">
                <div className="card-header bg-primary text-white d-flex justify-content-center">
                    <h2 className="my-0 font-weight-normal">Business Level 1</h2>
                </div>
                <div className="card-body">
                    <h1 className="card-title pricing-card-title">$0.015 <small className="text-muted">/ sms</small></h1>
                    <ul className="list-unstyled mt-3 mb-4">
                        <li><FaCheck/> 1,000 - 9,999 SMS</li>
                        <li><FaCheck/> 7 sms per International #</li>
                        <li><FaCheck/> 1 sms per Non Hormuud Numbers</li>
                        <li><FaCheck/> Valid for 90 Days</li>
                    </ul>
                    <Link className="btn btn-lg btn-block btn-primary" style={{float: 'right'}} to='/sms-buy' state={{ data: {min: 1000, max: 9999, price: 0.015} }}>Buy</Link>
                </div>
            </div>
        </div>
        <div className="col-md-4">
            <div className="card mb-4 box-shadow">
                <div className="card-header bg-primary text-white d-flex justify-content-center">
                    <h2 className="my-0 font-weight-normal">Business Level 2</h2>
                </div>
                <div className="card-body">
                    <h1 className="card-title pricing-card-title">$0.01 <small className="text-muted">/ sms</small></h1>
                    <ul className="list-unstyled mt-3 mb-4">
                        <li><FaCheck/> 10,000 - 49,999 SMS</li>
                        <li><FaCheck/> 7 sms per International #</li>
                        <li><FaCheck/> 1 sms per Non Hormuud Numbers</li>
                        <li><FaCheck/> Valid for 90 Days</li>
                    </ul>
                    <Link className="btn btn-lg btn-block btn-primary" style={{float: 'right'}} to='/sms-buy' state={{ data: {min: 10000, max: 49999, price: 0.01} }}>Buy</Link>
                </div>
            </div>
        </div>
        <div className="col-md-4">
            <div className="card mb-4 box-shadow">
                <div className="card-header bg-primary text-white d-flex justify-content-center">
                    <h2 className="my-0 font-weight-normal">Business Level 3</h2>
                </div>
                <div className="card-body">
                    <h1 className="card-title pricing-card-title">$0.008 <small className="text-muted">/ sms</small></h1>
                    <ul className="list-unstyled mt-3 mb-4">
                        <li><FaCheck/> 50,000+ SMS</li>
                        <li><FaCheck/> 10 sms per International #</li>
                        <li><FaCheck/> 2 sms per Non Hormuud Numbers</li>
                        <li><FaCheck/> Valid for 90 Days</li>
                    </ul>
                    <Link className="btn btn-lg btn-block btn-primary" style={{float: 'right'}} to='/sms-buy' state={{ data: {min: 50000, max: 100000, price: 0.008} }}>Buy</Link>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}
